import Distpicker from './distpicker'
export default Distpicker
